var _clipPath, _clipPath2, _clipPath3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEquansLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 2905 755",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M223.562,83.021L223.562,69.464L158.867,69.464L158.867,137.28L223.562,137.28L223.562,123.722L173.377,123.722L173.377,109.426L215.806,109.426L215.806,95.87L173.377,95.87L173.377,83.021L223.562,83.021Z",
    style: {
      fill: "rgb(0,30,57)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.613,104.222C329.613,84.609 314.169,68.71 291.357,68.71L286.279,68.71C263.467,68.71 248.022,84.609 248.022,104.222C248.022,123.836 263.467,139.735 286.279,139.735L290.677,139.735C297.668,139.853 305.239,140.492 320.506,142.796L328.199,131.068L328.199,131.034C324.771,130.439 321.68,129.93 318.863,129.486C325.68,123.046 329.613,114.108 329.613,104.222ZM262.554,104.222C262.554,91.869 272.308,83.242 286.279,83.242L291.357,83.242C305.324,83.242 315.081,91.869 315.081,104.222C315.081,116.575 305.324,125.202 291.357,125.202L286.279,125.202C272.308,125.202 262.554,116.575 262.554,104.222Z",
    style: {
      fill: "rgb(0,30,57)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.243,69.465L421.243,109.187C421.243,117.906 418.214,125.292 413.004,130.499C407.793,135.714 400.41,138.739 391.691,138.739L382.979,138.739C365.54,138.739 353.434,126.625 353.434,109.187L353.434,69.465L367.967,69.465L367.967,109.187C367.967,118.874 374.164,125.174 382.979,125.174L382.979,125.181L391.691,125.181L391.691,125.174C400.506,125.174 406.711,118.874 406.711,109.187L406.711,69.465L421.243,69.465Z",
    style: {
      fill: "rgb(0,30,57)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.263,137.281L517.11,137.281L487.237,69.466L469.533,69.466L439.611,137.307L455.492,137.307L462.265,121.951L494.479,121.951L501.263,137.281ZM468.111,108.697L477.779,86.775L478.987,86.775L488.655,108.697L468.111,108.697Z",
    style: {
      fill: "rgb(0,30,57)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.023,69.466L610.023,137.282L597.607,137.282L555.188,92.242L555.188,137.282L540.656,137.282L540.656,69.466L553.693,69.466L595.491,113.842L595.494,69.466L610.023,69.466Z",
    style: {
      fill: "rgb(0,30,57)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.17,90.821C657.468,89.971 657.095,89.004 657.095,87.874C657.095,83.992 660.371,81.09 668.979,81.09C673.503,81.09 677.13,82.541 679.73,83.992C681.174,84.864 682.411,85.82 683.645,86.862L691.703,74.671C690.798,74.076 689.358,73.198 688.324,72.658C683.914,70.335 677.13,68.009 668.407,68.009C650.311,68.009 639.553,77.216 639.553,87.874C639.553,89.251 639.682,90.533 639.941,91.715C644.025,110.973 679.161,107.037 679.161,117.902C679.161,122.271 675.202,125.657 666.151,125.657C664.082,125.657 662.181,125.45 660.448,125.107C657.14,124.453 654.425,123.279 652.342,122.075C650.414,121.011 648.834,119.752 647.478,118.385L636.155,128.076C638.198,130.107 640.683,131.861 643.737,133.409C645.414,134.303 647.36,135.185 649.576,135.957C654.115,137.549 659.795,138.734 666.708,138.734C685.388,138.734 696.703,129.044 696.703,117.902C696.703,96.578 664.47,98.672 658.17,90.821Z",
    style: {
      fill: "rgb(0,30,57)",
      fillRule: "nonzero"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.355,145.762L7.502,189.263L-32.474,7.436L165.377,-36.065L205.355,145.762Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.169,0.409C49.199,0.653 0.697,37.905 0,98.73L0,101.377C0.173,117.069 3.478,134.275 10.181,152.789C-0.517,82.432 43.009,42.13 142.161,50.968L173.397,3.667C158.377,1.514 144.14,0.446 130.774,0.409L129.169,0.409Z",
    style: {
      fill: "url(#_Linear2)"
    }
  })), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.728,162.579L13.065,192.626L-13.025,73.957L123.637,43.909L149.728,162.579Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.628,167.081C23.927,110.857 56.972,94.258 111.553,97.301L129.254,70.508C122.355,69.81 115.663,69.455 109.2,69.455C47.67,69.455 7.448,101.278 19.628,167.081Z",
    style: {
      fill: "url(#_Linear4)"
    }
  })), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.751,178.04L30.946,196.026L14.179,119.767L95.984,101.781L112.751,178.04Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.686,181L27.69,181C37.104,148.903 55.613,133.954 86.447,137.038L99.288,117.601C94.97,117.077 90.786,116.811 86.757,116.811C51.481,116.807 27.642,137.115 27.686,181Z",
    style: {
      fill: "url(#_Linear6)"
    }
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear2",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-105.9,-23.2835,-23.2835,105.9,97.0677,74.2621)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(62,187,149)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "rgb(53,181,147)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "rgb(38,148,133)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    style: {
      stopColor: "rgb(0,80,94)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(0,30,57)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear4",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-105.709,-23.2416,-23.2416,105.709,105.558,110.087)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(62,187,149)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "rgb(53,181,147)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "rgb(38,148,133)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    style: {
      stopColor: "rgb(0,80,94)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(0,30,57)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear6",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-105.702,-23.24,-23.24,105.702,111.681,138.303)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(62,187,149)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "rgb(53,181,147)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "rgb(38,148,133)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    style: {
      stopColor: "rgb(0,80,94)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(0,30,57)",
      stopOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEquansLogo);
export default __webpack_public_path__ + "static/media/equans-logo.ded9fb19242309de205e15f7f473f29f.svg";
export { ForwardRef as ReactComponent };